export const getSetupIntentTokenAction = 'getSetupIntentTokenAction';
export const getManageSubscriptionLinkAction =
  'getManageSubscriptionLinkAction';
